import moment from 'moment'
import _ from 'lodash'

export default function DateFilter (value, format) {
  if (value) {
    if (_.isString(value)) {
      if (/\d+\/\d+\/\d+/.test(value)) {
        value = moment(value, 'DD-MM-YYYY')
      } else {
        value = moment(value)
      }
    }
    return moment(value).format(format)
  }
}



// WEBPACK FOOTER //
// ./src/filters/Date.js